
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
const canUseDOM = !!(
  (typeof window !== 'undefined' &&
  window.document && window.document.createElement)
)

export default class Divvit extends React.Component {
  static propTypes = {
    frontendId: PropTypes.string,
    divvitTagUrl: PropTypes.string
  }

  constructor(props) {
    super(props)

    const {frontendId, divvitTagUrl} = props

    if (!frontendId || !divvitTagUrl || !canUseDOM) {
      return
    }

    if (!window.divvit) {
      /* eslint-disable */
      !function(){var t=window.divvit=window.divvit||[];if(t.DV_VERSION="1.0.0",t.init=function(e){if(!t.bInitialized){var i=document.createElement("script");i.setAttribute("type","text/javascript"),i.setAttribute("async",!0),i.setAttribute("src",divvitTagUrl+"?id="+e);var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(i,n)}},!t.bInitialized){t.functions=["customer","pageview","cartAdd","cartRemove","cartUpdated","orderPlaced","nlSubscribed","dv"];for(var e=0;e<t.functions.length;e++){var i=t.functions[e];t[i]=function(e){return function(){return Array.prototype.unshift.call(arguments,e),t.push(arguments),t}}(i)}}}();
      /* eslint-enable */
    }

    if (window.divvit) {
      window.divvit.init(frontendId)
      window.divvit.pageview()
    }
  }

  shouldComponentUpdate() {
    return false
  }

  componentWillUnmount() {
    if (!canUseDOM) return false

    delete window.divvit
  }

  render() {
    return false
  }
}



// WEBPACK FOOTER //
// ./client/components/Divvit/index.js